export const allCalId = "190425225021";
export const allMPCalId = "190425225056";
export const allAKCalId = "190425225055";
export const allPECalId = "190425225058";
export const allPPCalId = "190425225057";
export const allRACalId = "190425225059";
